module.exports = __webpack_public_path__ + "img/m_4.b711adc2.png";